import { render, staticRenderFns } from "./ServiceDuration.vue?vue&type=template&id=1b380989&scoped=true"
import script from "./ServiceDuration.vue?vue&type=script&lang=js"
export * from "./ServiceDuration.vue?vue&type=script&lang=js"
import style0 from "./ServiceDuration.vue?vue&type=style&index=0&id=1b380989&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b380989",
  null
  
)

export default component.exports